export default __webpack_public_path__ + "static/media/dropdown.28d23717.svg";